<template>
    <div id="app">
        <router-view />
        <van-tabbar v-model="active">
            <van-tabbar-item to="/index">
                <span>首页</span>
                <template #icon="props">
                    <img :src="props.active ? icon1.active : icon1.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/ryCapital">
                <span>资产列表</span>
                <template #icon="props">
                    <img :src="props.active ? icon4.active : icon4.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/consult">
                <span>我要咨询</span>
                <template #icon="props">
                    <img :src="props.active ? icon3.active : icon3.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/mine">
                <span>我的</span>
                <template #icon="props">
                    <img :src="props.active ? icon2.active : icon2.inactive" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import { getToken, setToken } from "@/util/auth";
import { login } from "@/util/login";
export default {
    data() {
        return {
            active: 0,
            icon1: {
                active: require("@/assets/image/home1@2x.png"),
                inactive: require("@/assets/image/home@2x.png"),
            },
            icon2: {
                active: require("@/assets/image/my1@2x.png"),
                inactive: require("@/assets/image/my@2x.png"),
            },
            icon3: {
                active: require("@/assets/image/consult.png"),
                inactive: require("@/assets/image/consult1.png"),
            },
            icon4: {
                active: require("@/assets/image/assets.png"),
                inactive: require("@/assets/image/assets1.png"),
            },
        };
    },
    created() {
        document.title = "快速报修";
    },
    mounted() {},
    watch: {
        $route(to, from) {
            switch (to.path) {
                case "/index":
                    this.active = 0;
                    break;
                case "/ryCapital":
                    this.active = 1;
                    break;
                case "/consult":
                    this.active = 2;
                    break;
                case "/mine":
                    this.active = 3;
                    break;
            }
        },
    },
};
</script>
<style>
	 

@media only screen and (min-width: 1024px) {
    html,
    body {
        font-size: 1000px !important;
        max-width: 750px;
        margin: 0 auto;
    }
}

@media (min-device-width: 768px) and (max-device-width: 1024px) {
    html,
    body {
        font-size: 760px !important;
        max-width: 750px;
        margin: 0 auto;
    }
}
@media (min-device-width: 720px) and (max-device-width: 768px) {
    html,
    body {
        font-size: 700px !important;
        margin: 0 auto;
    }
}
@media (min-device-width: 480px) and (max-device-width: 720px) {
    html,
    body {
        font-size: 380px !important;
        margin: 0 auto;
    }
}
#app {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 20px;
    background: #e9eef2;
}
.rect1 {
    font-size: 20px;
}
.van-tabbar {
    z-index: 2000;
}
</style>
